/**
 * Keep Shopify's HTML parser/fallback transport off the successful Constructor
 * path. The first error or empty response downloads this small chunk once.
 */
export const loadShopifyCollectionFallback = (...args) =>
  import(
    /* webpackChunkName: "external_constructor-collection-fallback" */ './fallback'
  ).then((module) => module.loadShopifyCollectionFallback(...args));

export default loadShopifyCollectionFallback;
